export default __webpack_public_path__ + "media/images/icons/info-circle-solid-92d3ccd584288cd59ae40f82f2f75b45.svg";